/* FLUXE AND CO — interactions */
(function () {
  'use strict';

  /* ---------- i18n ----------
     window.FLUXE_I18N / window.FLUXE_LOCALE are injected by layout/theme.liquid
     ONLY on the Spanish (Mexico) market. When they are absent, T() returns the
     original English string and FX_LOCALE stays 'en-US' — so the US / CA / AU /
     IE / NZ markets behave exactly as they did before. */
  function T(s){ var d = window.FLUXE_I18N; return (d && d[s]) || s; }
  var FX_LOCALE = window.FLUXE_LOCALE || 'en-US';
  /* Market/locale prefix: '/' on the primary store, '/es-mx/' on the Mexican
     market. Hardcoded '/cart' URLs dropped that prefix and threw Spanish
     shoppers back onto the English store. '/' + 'cart' === '/cart', so the
     English behaviour is unchanged. */
  var FX_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  var VAR = {
    "pack2": {"S":43933311696983,"M":43933311729751,"L":43933311762519,"XL":43933311795287,"XXL":43933311828055,"3XL":43933311860823,"4XL":43933311893591},
    "pack4": {"S":43933311926359,"M":43933311959127,"L":43933311991895,"XL":43933312024663,"XXL":43933312057431,"3XL":43933312090199,"4XL":43933312122967}
  };

  ready(function () {

    /* ---------- Variant wiring (pack + size -> hidden id) ---------- */
    (function () {
      var wire = document.querySelector('[data-variant-wire]');
      var hidden = document.getElementById('fluxe-variant-id');
      if (!wire || !hidden) return;
      var wireForm = wire.closest('form');
      var wireAtc  = wireForm ? wireForm.querySelector('[type=submit]') : null;
      /* Size labels are not written the same way on every product ("XXL" on one
         colour, "2XL" on another). Normalise before matching so a label mismatch
         can never silently keep the previously selected variant. */
      function normSize(s){
        var n = String(s == null ? '' : s).trim().toLowerCase().replace(/\s+/g,'');
        return n.replace(/^(x{2,})l$/, function(_, xs){ return xs.length + 'xl'; });
      }
      function lookupVariant(group, size){
        if (!group || !size) return null;
        if (group[size]) return group[size];
        var want = normSize(size);
        for (var k in group){ if (normSize(k) === want) return group[k]; }
        return null;
      }
      function recompute(){
        /* Prefer the per-product map injected by landing.liquid; fall back to the
           hardcoded map so the original product keeps working if the script is absent. */
        var MAP = (window.FLUXE_VARIANTS && Object.keys(window.FLUXE_VARIANTS).length) ? window.FLUXE_VARIANTS : VAR;
        var card = wire.querySelector('.pack.is-selected[data-pack]') || wire.querySelector('.pack[data-pack]');
        if(!card) return;
        var pack = card.getAttribute('data-pack');
        var sb = card.querySelector('.size-btn.is-active') || card.querySelector('.size-btn');
        var size = sb ? sb.getAttribute('data-size') : null;
        if(!pack || !size) return;
        var id = lookupVariant(MAP[pack], size);
        if (id){
          hidden.value = id;
          if (wireAtc) wireAtc.disabled = false;
        } else if (wireAtc) {
          /* No variant matches this pack + size: block the add instead of shipping
             whatever variant was selected before (that sold L instead of 2XL). */
          wireAtc.disabled = true;
        }
      }
      wire.addEventListener('click', function (e) {
        var sb = e.target.closest('.size-btn');
        if (sb) {
          var card = sb.closest('.pack[data-pack]');
          wire.querySelectorAll('.pack[data-pack]').forEach(function(p){ p.classList.remove('is-selected'); });
          if (card) card.classList.add('is-selected');
          var grp = sb.closest('[data-sizes]');
          if (grp) { grp.querySelectorAll('.size-btn').forEach(function(b){ b.classList.remove('is-active'); }); sb.classList.add('is-active'); }
        } else {
          var c = e.target.closest('.pack[data-pack]');
          if (c) { wire.querySelectorAll('.pack[data-pack]').forEach(function(p){ p.classList.remove('is-selected'); }); c.classList.add('is-selected'); }
        }
        recompute();
      });
      recompute();
    })();

    /* ---------- Generic variant picker (standard product page) ---------- */
    (function () {
      var form = document.querySelector('form[data-product-form]');
      if (!form) return;
      var jsonEl = form.querySelector('[data-variant-json]');
      var hidden = form.querySelector('[data-variant-id]');
      var btn    = form.querySelector('[data-atc-btn]');
      var priceEl = document.querySelector('[data-price]');
      if (!jsonEl || !hidden) return;
      var variants;
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      function money(c){
        var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
        try { return new Intl.NumberFormat(undefined, {style:'currency', currency:cur}).format(c/100); }
        catch(e){ return '$' + (c/100).toFixed(2); }
      }
      function selected(){
        return Array.prototype.map.call(form.querySelectorAll('[data-opt-index]'), function(group){
          var a = group.querySelector('.size-btn.is-active') || group.querySelector('.size-btn');
          return a ? a.getAttribute('data-opt-value') : null;
        });
      }
      function recompute(){
        var sel = selected();
        var match = variants.find(function(v){
          return v.options.every(function(o, i){ return sel[i] == null || o === sel[i]; });
        });
        if (!match) return;
        hidden.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (btn){
          if (match.available){ btn.disabled = false; btn.textContent = T('Add to cart'); }
          else { btn.disabled = true; btn.textContent = T('Sold out'); }
        }
      }
      form.addEventListener('click', function(e){
        var b = e.target.closest('.size-btn');
        if (!b) return;
        e.preventDefault();
        var group = b.closest('[data-opt-index]');
        if (group){ group.querySelectorAll('.size-btn').forEach(function(x){ x.classList.remove('is-active'); }); b.classList.add('is-active'); }
        recompute();
      });
      recompute();
    })();

    /* ---------- Image gallery / carousel ---------- */
    document.querySelectorAll('[data-gallery]').forEach(function (g) {
      var slides = Array.prototype.slice.call(g.querySelectorAll('.gallery__slide'));
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('.gallery__thumb'));
      if (!slides.length) return;
      var idx = 0;
      function show(i){
        idx = (i + slides.length) % slides.length;
        slides.forEach(function(s,n){ s.classList.toggle('is-active', n===idx); });
        thumbs.forEach(function(t,n){ t.classList.toggle('is-active', n===idx); });
      }
      var prev = g.querySelector('[data-gallery-prev]');
      var next = g.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function(){ show(idx-1); });
      if (next) next.addEventListener('click', function(){ show(idx+1); });
      thumbs.forEach(function(t){ t.addEventListener('click', function(){ show(parseInt(t.getAttribute('data-thumb'),10)||0); }); });
      var x0=null;
      var main = g.querySelector('.gallery__main');
      if (main) {
        main.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, {passive:true});
        main.addEventListener('touchend', function(e){ if(x0===null) return; var dx=e.changedTouches[0].clientX-x0; if(Math.abs(dx)>40){ show(dx<0?idx+1:idx-1); } x0=null; }, {passive:true});
      }
    });

    /* ---------- FAQ accordion ---------- */
    document.querySelectorAll('.faq__q').forEach(function (q) {
      q.addEventListener('click', function () { q.closest('.faq__item').classList.toggle('is-open'); });
    });

    /* ---------- Countdown ---------- */
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var end = new Date().getTime() + (parseInt(el.getAttribute('data-countdown'),10)||15)*60000;
      function pad(n){ return (n<10?'0':'')+n; }
      function tick(){
        var l = Math.max(0, Math.floor((end - new Date().getTime())/1000));
        var h=el.querySelector('[data-h]'), m=el.querySelector('[data-m]'), s=el.querySelector('[data-s]');
        if(h)h.textContent=pad(Math.floor(l/3600)); if(m)m.textContent=pad(Math.floor((l%3600)/60)); if(s)s.textContent=pad(l%60);
      }
      tick(); setInterval(tick,1000);
    });

    /* ---------- Estimated delivery = today + 8 business days ---------- */
    (function () {
      var els = document.querySelectorAll('[data-delivery-date]');
      if (!els.length) return;
      var d = new Date(); var added = 0;
      while (added < 8) { d.setDate(d.getDate()+1); var day=d.getDay(); if(day!==0 && day!==6) added++; }
      var txt = d.toLocaleDateString(FX_LOCALE, { weekday:'long', month:'long', day:'numeric' });
      els.forEach(function(e){ e.textContent = txt; });
    })();

    /* ---------- Sticky CTA -> scroll to buy box ---------- */
    document.querySelectorAll('[data-sticky-cta]').forEach(function (b) {
      b.addEventListener('click', function () { var t=document.getElementById('buybox'); if(t) t.scrollIntoView({behavior:'smooth', block:'center'}); });
    });

    /* ---------- Lightbox modal (size guide) ---------- */
    (function () {
      function closeAll(){ document.querySelectorAll('.lb.is-open').forEach(function(m){ m.classList.remove('is-open'); }); document.body.style.overflow=''; }
      document.querySelectorAll('[data-modal-open]').forEach(function (t) {
        t.addEventListener('click', function (e) {
          e.preventDefault();
          var m = document.querySelector('.lb[data-modal="' + t.getAttribute('data-modal-open') + '"]');
          if (m) { m.classList.add('is-open'); m.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
        });
      });
      document.querySelectorAll('[data-modal-close]').forEach(function (c) { c.addEventListener('click', closeAll); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    })();

    /* ---------- Navigation drawer (hamburger) ---------- */
    (function () {
      var drawer = document.querySelector('[data-nav-drawer]');
      if (!drawer) return;
      function open(){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
      function close(){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
      document.querySelectorAll('[data-nav-toggle]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); open(); }); });
      drawer.querySelectorAll('[data-nav-close]').forEach(function(b){ b.addEventListener('click', close); });
      document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
    })();

    /* ---------- Sticky CTA: show only from the "first-ever" section to bottom ---------- */
    (function () {
      var sticky = document.querySelector('.sticky-cta');
      var trigger = document.getElementById('rich-start');
      if (!sticky || !trigger) return;
      function onScroll(){
        var vis = trigger.getBoundingClientRect().top < window.innerHeight;
        sticky.classList.toggle('is-visible', vis);
        document.body.classList.toggle('sticky-cta-on', vis);
      }
      window.addEventListener('scroll', onScroll, {passive:true});
      window.addEventListener('resize', onScroll);
      onScroll();
    })();

    /* ---------- Cart drawer (Eve & Co style) ---------- */
    (function () {
      var drawer = document.querySelector('[data-cart-drawer]');
      if (!drawer) return;
      /* compare-at price (cents) per variant -> for the "you save" display */
      var COMPARE = {};
      Object.keys(VAR).forEach(function(pack){
        Object.keys(VAR[pack]).forEach(function(size){
          COMPARE[VAR[pack][size]] = (pack === 'pack2') ? 7998 : 15996;
        });
      });
      /* Merge real compare-at prices for the current product (dynamic variants). */
      if (window.FLUXE_COMPARE) {
        Object.keys(window.FLUXE_COMPARE).forEach(function(id){ COMPARE[id] = window.FLUXE_COMPARE[id]; });
      }
      function money(c){
        var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
        try { return new Intl.NumberFormat(undefined, {style:'currency', currency:cur}).format(c/100); }
        catch(e){ return '$' + (c/100).toFixed(2); }
      }
      function upsellPriceHtml(priceCents, compareCents){
        return (compareCents && compareCents > priceCents ? '<s class="cart-upsell__compare">'+money(compareCents)+'</s> ' : '') + money(priceCents);
      }
      function open(){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; document.body.classList.add('cart-open'); }
      function close(){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; document.body.classList.remove('cart-open'); }

      var itemsEl   = drawer.querySelector('[data-cart-items]');
      var upsellEl  = drawer.querySelector('[data-cart-upsell]');
      var upsell2El = drawer.querySelector('[data-cart-upsell-2]');
      var foot      = drawer.querySelector('[data-cart-foot]');
      var totalEl   = drawer.querySelector('[data-cart-total]');
      var compareEl = drawer.querySelector('[data-cart-compare]');
      var savingsEl = drawer.querySelector('[data-cart-savings]');

      /* ---- Second upsell: the "extra layer" product (added by ID) ---- */
      var extraProduct = null;
      if (upsell2El) {
        var xEl = upsell2El.querySelector('[data-upsell2-data]');
        try { extraProduct = JSON.parse(xEl.textContent); } catch(e) { extraProduct = null; }
      }

      /* ---- Smart upsell: propose ANOTHER colour, same size, with a "next" arrow ---- */
      var upsellStage = upsellEl ? upsellEl.querySelector('[data-upsell-stage]') : null;
      var upsellProducts = [];
      if (upsellEl) {
        var dEl = upsellEl.querySelector('[data-upsell-data]');
        try { upsellProducts = JSON.parse(dEl.textContent); } catch(e) { upsellProducts = []; }
      }
      /* Merge compare-at prices for every upsell colour + the extra product, so
         cart line items from those products also show their crossed-out price
         (COMPARE was only seeded with the current product's variants). */
      (upsellProducts || []).forEach(function(p){
        (p.variants || []).forEach(function(v){ if (v.compare && v.compare > v.price){ COMPARE[v.id] = v.compare; } });
      });
      if (extraProduct){
        (extraProduct.variants || []).forEach(function(v){ if (v.compare && v.compare > v.price){ COMPARE[v.id] = v.compare; } });
      }

      var upsellList = [];     // candidate products (colours not already in cart)
      var upsellIdx = 0;       // which candidate is shown
      var wantSize = null;     // size the customer already chose
      var wantBundle = null;   // pack/bundle the customer already chose

      function sizesOf(p){
        var seen = {}, out = [];
        p.variants.forEach(function(v){
          var s = v.options[p.sizeIndex];
          if (s != null && !seen[s] && v.available){ seen[s] = true; out.push(s); }
        });
        return out;
      }
      function bundlesOf(p){
        var seen = {}, out = [];
        p.variants.forEach(function(v){
          var b = v.options[p.bundleIndex];
          if (b != null && !seen[b] && v.available){ seen[b] = true; out.push(b); }
        });
        return out;
      }
      /* All distinct sizes (available or not) so the customer's chosen size always
         appears in the dropdown and can be pre-selected. */
      function allSizesOf(p){
        var seen = {}, out = [];
        p.variants.forEach(function(v){
          var s = v.options[p.sizeIndex];
          if (s != null && !seen[s]){ seen[s] = true; out.push(s); }
        });
        return out;
      }
      /* Case/space-insensitive match of the wanted size against a size list. */
      function matchSize(sizes, want){
        if (want == null) return null;
        var w = String(want).trim().toLowerCase().replace(/\s+/g,'');
        for (var i = 0; i < sizes.length; i++){
          if (String(sizes[i]).trim().toLowerCase().replace(/\s+/g,'') === w) return sizes[i];
        }
        return null;
      }
      /* The image to show for a given variant: its own image if set, else the
         product's featured image. */
      function variantImg(p, v){ return (v && v.image) ? v.image : p.image; }
      /* Pick the "3 + 1" (bigger) pack: detect it by label, else fall back to the
         last bundle option (the larger pack in this catalog). Used everywhere so
         every upsell defaults to the 3+1 pack. */
      function preferBigBundle(bundles){
        for (var i = 0; i < bundles.length; i++){
          var l = (bundles[i] || '').toString().toLowerCase();
          if (l.indexOf('3') > -1 || l.indexOf('4') > -1 || l.indexOf('+1') > -1){ return bundles[i]; }
        }
        return bundles[bundles.length - 1] || bundles[0];
      }
      function variantOf(p, bundle, size){
        var exact = p.variants.filter(function(v){ return v.options[p.bundleIndex] === bundle && v.options[p.sizeIndex] === size && v.available; });
        if (exact.length) return exact[0];
        var bySize = p.variants.filter(function(v){ return v.options[p.sizeIndex] === size && v.available; });
        return bySize[0] || null;
      }
      function upsellRecalc(card){
        if (!upsellList.length) return;
        var p = upsellList[upsellIdx];
        var packSel = card.querySelector('[data-upsell-pack]');
        var sizeSel = card.querySelector('[data-upsell-size]');
        var bundle = packSel ? packSel.value : bundlesOf(p)[0];
        var size   = sizeSel ? sizeSel.value : sizesOf(p)[0];
        var v = variantOf(p, bundle, size);
        var add   = card.querySelector('[data-upsell-add]');
        var price = card.querySelector('[data-upsell-price]');
        if (add) add.setAttribute('data-variant-id', v ? v.id : '');
        if (price && v) price.innerHTML = upsellPriceHtml(v.price, v.compare);
        var imgEl = card.querySelector('[data-upsell-img]');
        var imgSrc = variantImg(p, v);
        if (imgEl && imgEl.tagName === 'IMG' && imgSrc) imgEl.src = imgSrc;
      }
      function buildUpsell(cart){
        var inCart = {};
        wantSize = null; wantBundle = null;
        (cart.items || []).forEach(function(it){
          inCart[it.product_id] = true;
          if (wantSize == null && it.options_with_values){
            it.options_with_values.forEach(function(o){
              var n = (o.name || '').toLowerCase();
              var val = o.value;
              var nameIsSize = (n.indexOf('size') > -1 || n.indexOf('taille') > -1);
              var nameIsBundle = (n.indexOf('pack') > -1 || n.indexOf('bundle') > -1 || n.indexOf('quantity') > -1);
              /* Bundle values look like "Pack of 3 + 1 free"; size values are short
                 tokens like S/M/L/XL. Classify by NAME first, then by VALUE shape. */
              var valIsBundle = /pack|free|bundle|\+|\d\s*x/i.test(String(val));
              if (nameIsSize){ wantSize = val; }
              else if (nameIsBundle){ wantBundle = val; }
              else if (valIsBundle){ wantBundle = val; }
              else { wantSize = val; }
            });
          }
        });
        upsellList = upsellProducts.filter(function(p){
          return !inCart[p.id] && p.variants.some(function(v){ return v.available; });
        });
        if (upsellIdx >= upsellList.length) upsellIdx = 0;
      }
      function renderUpsell(cart){
        if (!upsellEl || !upsellStage) return;
        buildUpsell(cart);
        drawUpsellCard();
      }

      /* ---- Second upsell rendering: hide when already in cart or dismissed ---- */
      function extraFirstAvailable(){
        if (!extraProduct) return null;
        var av = extraProduct.variants.filter(function(v){ return v.available; });
        return av[0] || null;
      }
      function renderUpsell2(cart){
        if (!upsell2El || !extraProduct) return;
        var stage = upsell2El.querySelector('[data-upsell-stage]');
        if (!stage) return;
        if (upsell2El.dataset.dismissed){ upsell2El.style.display = 'none'; return; }
        var inCart = (cart.items || []).some(function(it){ return it.product_id === extraProduct.id; });
        var v = extraFirstAvailable();
        if (inCart || !v){ upsell2El.style.display = 'none'; return; }
        upsell2El.style.display = '';
        var multi = extraProduct.variants.filter(function(x){ return x.available; }).length > 1;
        stage.innerHTML =
          '<div class="cart-upsell__card">'+
            (extraProduct.image ? '<img class="cart-upsell__img" src="'+extraProduct.image+'" alt="">' : '<div class="cart-upsell__img cart-upsell__img--ph"></div>')+
            '<div class="cart-upsell__body">'+
              '<a class="cart-upsell__ttl" href="'+extraProduct.url+'">'+extraProduct.title+'</a>'+
              '<div class="cart-upsell__price" data-upsell-price>'+ upsellPriceHtml(v.price, v.compare) +'</div>'+
              (multi ? '<div class="cart-upsell__row">'+
                '<select class="cart-upsell__select" data-upsell2-variant aria-label="'+T('Option')+'">'+
                  extraProduct.variants.filter(function(x){ return x.available; }).map(function(x){
                    return '<option value="'+x.id+'">'+ (x.title && x.title !== 'Default Title' ? x.title : extraProduct.title) +'</option>';
                  }).join('')+
                '</select>'+
              '</div>' : '')+
              '<button type="button" class="cart-upsell__add" data-upsell2-add data-variant-id="'+v.id+'">'+T('Add')+'</button>'+
            '</div>'+
          '</div>';
      }
      function drawUpsellCard(){
        if (!upsellEl || !upsellStage) return;
        if (upsellEl.dataset.dismissed){ upsellEl.style.display = 'none'; return; }
        if (!upsellList.length){ upsellEl.style.display = 'none'; return; }
        upsellEl.style.display = '';
        var p = upsellList[upsellIdx];
        var bundles = bundlesOf(p);
        var sizes = allSizesOf(p);
        var curBundle = preferBigBundle(bundles);
        var curSize   = matchSize(sizes, wantSize) || (sizesOf(p)[0]) || sizes[0];
        var v = variantOf(p, curBundle, curSize);
        var img = variantImg(p, v);
        var more = upsellList.length > 1;
        upsellStage.innerHTML =
          '<div class="cart-upsell__card cart-upsell__card--v2">'+
            '<div class="cart-upsell__top">'+
              (more ? '<button type="button" class="cart-upsell__arrow cart-upsell__arrow--prev" data-upsell-prev aria-label="'+T('Previous colour')+'">&lsaquo;</button>' : '')+
              (img ? '<img class="cart-upsell__img" data-upsell-img src="'+img+'" alt="">' : '<div class="cart-upsell__img cart-upsell__img--ph" data-upsell-img></div>')+
              '<div class="cart-upsell__body">'+
                '<a class="cart-upsell__ttl" href="'+p.url+'">'+p.title+'</a>'+
                '<div class="cart-upsell__price" data-upsell-price>'+ upsellPriceHtml(v ? v.price : p.price, v ? v.compare : 0) +'</div>'+
              '</div>'+
              (more ? '<button type="button" class="cart-upsell__arrow cart-upsell__arrow--next" data-upsell-next aria-label="'+T('Next colour')+'">&rsaquo;</button>' : '')+
            '</div>'+
            '<div class="cart-upsell__row">'+
              (bundles.length ? '<select class="cart-upsell__select" data-upsell-pack aria-label="'+T('Pack')+'">'+
                bundles.map(function(b){ return '<option value="'+b+'"'+(b===curBundle?' selected':'')+'>'+b+'</option>'; }).join('')+
              '</select>' : '')+
              (sizes.length ? '<select class="cart-upsell__select" data-upsell-size aria-label="'+T('Size')+'">'+
                sizes.map(function(s){ return '<option value="'+s+'"'+(s===curSize?' selected':'')+'>'+s+'</option>'; }).join('')+
              '</select>' : '')+
            '</div>'+
            '<div class="cart-upsell__actions">'+
              '<button type="button" class="cart-upsell__nothanks" data-upsell-dismiss>'+T('No, thanks')+'</button>'+
              '<button type="button" class="cart-upsell__add" data-upsell-add data-variant-id="'+(v?v.id:'')+'">'+T('Add')+'</button>'+
            '</div>'+
          '</div>';
      }

      function render(cart){
        if(!cart.items || !cart.items.length){
          itemsEl.innerHTML = '<div class="cart-drawer__empty">'+T('Your cart is empty')+'</div>';
          if(foot) foot.style.display='none';
          if(upsellEl) upsellEl.style.display='none';
          if(upsell2El) upsell2El.style.display='none';
          return;
        }
        /* Show at most ONE upsell in the drawer so the cart items stay visible.
           Priority: the "another pack" colour upsell; fall back to the extra-layer one. */
        renderUpsell(cart);
        var oneShown = upsellEl && upsellEl.style.display !== 'none' && !upsellEl.dataset.dismissed;
        if (oneShown){
          if (upsell2El) upsell2El.style.display = 'none';
        } else {
          renderUpsell2(cart);
        }
        var compareTotal = 0;
        itemsEl.innerHTML = cart.items.map(function(it){
          var cmp = (COMPARE[it.variant_id] || 0) * it.quantity;
          compareTotal += (cmp || it.final_line_price);
          var purl = it.url || (FX_ROOT + 'products/' + (it.handle || ''));
          return '<div class="cart-drawer__item">'+
            '<a class="cart-drawer__item-imglink" href="'+purl+'">'+ (it.image ? '<img src="'+it.image+'" alt="'+ (it.product_title || '') +'">' : '<div class="cart-drawer__item-ph"></div>') +'</a>'+
            '<div style="flex:1">'+
              '<a class="ttl" href="'+purl+'">'+it.product_title+'</a>'+
              '<div class="meta">'+ (it.variant_title && it.variant_title!=='Default Title' ? it.variant_title : '') +'</div>'+
              '<div class="cart-drawer__item-qty">'+
                '<button class="cart-drawer__delete" type="button" data-cart-remove="'+it.key+'" aria-label="'+T('Remove')+'">'+T('Delete')+'</button>'+
                '<button class="cart-drawer__qbtn" type="button" data-cart-minus="'+it.key+'" data-qty="'+it.quantity+'" aria-label="'+T('Remove one')+'">&minus;</button>'+
                '<span class="cart-drawer__qty">'+it.quantity+'</span>'+
                '<button class="cart-drawer__qbtn" type="button" data-cart-plus="'+it.key+'" data-qty="'+it.quantity+'" aria-label="'+T('Add one')+'">+</button>'+
              '</div>'+
            '</div>'+
            '<div class="cart-drawer__price">'+ (cmp ? '<span class="compare">'+money(cmp)+'</span>' : '') + money(it.final_line_price) +'</div>'+
          '</div>';
        }).join('');
        if(totalEl) totalEl.textContent = money(cart.total_price);
        var saved = compareTotal - cart.total_price;
        if(compareEl) compareEl.textContent = saved > 0 ? money(compareTotal) : '';
        if(savingsEl){ if(saved > 0){ savingsEl.style.display=''; savingsEl.textContent = T('You save') + ' ' + money(saved) + ' 🎉'; } else { savingsEl.style.display='none'; } }
        if(foot) foot.style.display='';
      }
      function fetchCart(openAfter){
        return fetch(FX_ROOT + 'cart.js', {headers:{'Accept':'application/json'}})
          .then(function(r){ return r.json(); })
          .then(function(c){ render(c); if(openAfter) open(); })
          .catch(function(){});
      }
      function change(key, qty){
        fetch(FX_ROOT + 'cart/change.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({ id:key, quantity:qty }) })
          .then(function(r){ return r.json(); }).then(render);
      }

      /* Add to cart → add the item, then REDIRECT to the full /cart page
         (no drawer/popup). A short "Adding…" loader confirms the click. */
      document.querySelectorAll('form[data-atc-form], form[action*="/cart/add"]').forEach(function(form){
        form.addEventListener('submit', function(e){
          e.preventDefault();
          var btn = form.querySelector('[type=submit]'); var orig = btn ? btn.textContent : '';
          if(btn){ btn.disabled=true; btn.textContent=T('Adding…'); }
          document.body.classList.add('cart-open');
          ppShowAdding(T('Opening your cart…'));
          fetch(FX_ROOT + 'cart/add.js', { method:'POST', body:new FormData(form), headers:{'Accept':'application/json'} })
            .then(function(r){ return r.json(); })
            .then(function(){ window.location.href = FX_ROOT + 'cart'; })
            .catch(function(){ window.location.href = FX_ROOT + 'cart'; });
        });
      });
      /* open / close */
      document.querySelectorAll('[data-cart-toggle]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); fetchCart(true); }); });
      drawer.querySelectorAll('[data-cart-close]').forEach(function(b){ b.addEventListener('click', close); });
      document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
      /* qty controls */
      drawer.addEventListener('click', function(e){
        var rm = e.target.closest('[data-cart-remove]');
        var pl = e.target.closest('[data-cart-plus]');
        var mn = e.target.closest('[data-cart-minus]');
        if(rm){ change(rm.getAttribute('data-cart-remove'), 0); }
        else if(pl){ change(pl.getAttribute('data-cart-plus'), (parseInt(pl.getAttribute('data-qty'),10)||1)+1); }
        else if(mn){ change(mn.getAttribute('data-cart-minus'), Math.max(0,(parseInt(mn.getAttribute('data-qty'),10)||1)-1)); }
      });
      /* upsell: change size -> update variant; arrow -> next colour; add -> quick-add */
      if (upsellEl) {
        upsellEl.addEventListener('change', function(e){
          var sel = e.target.closest('[data-upsell-pack],[data-upsell-size]');
          if(!sel) return;
          var card = sel.closest('.cart-upsell__card');
          if(card) upsellRecalc(card);
        });
        upsellEl.addEventListener('click', function(e){
          var prev = e.target.closest('[data-upsell-prev]');
          if(prev){ if(upsellList.length){ upsellIdx = (upsellIdx - 1 + upsellList.length) % upsellList.length; drawUpsellCard(); } return; }
          var next = e.target.closest('[data-upsell-next]');
          if(next){ if(upsellList.length){ upsellIdx = (upsellIdx + 1) % upsellList.length; drawUpsellCard(); } return; }
          var add = e.target.closest('[data-upsell-add]');
          if(!add) return;
          var id = add.getAttribute('data-variant-id');
          if(!id) return;
          add.disabled = true; var orig = add.textContent; add.textContent = T('Adding…');
          fetch(FX_ROOT + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({ id:id, quantity:1 }) })
            .then(function(r){ return r.json(); })
            .then(function(){
              var code = upsellEl.getAttribute('data-upsell-code');
              if(code){ return fetch(FX_ROOT + 'discount/' + encodeURIComponent(code), {headers:{'Accept':'text/html'}}).catch(function(){}); }
            })
            .then(function(){ fetchCart(false); })
            .catch(function(){})
            .then(function(){ add.disabled = false; add.textContent = orig; });
        });
      }
      /* ---- Close (dismiss) the in-cart upsell banners ---- */
      drawer.addEventListener('click', function(e){
        var dis = e.target.closest('[data-upsell-dismiss]');
        if (dis){
          var b2 = dis.closest('[data-cart-upsell],[data-cart-upsell-2]');
          if (b2){ b2.dataset.dismissed = '1'; b2.style.display = 'none'; }
        }
      });

      /* ---- Second upsell: variant select + quick-add ---- */
      if (upsell2El){
        upsell2El.addEventListener('change', function(e){
          var sel = e.target.closest('[data-upsell2-variant]');
          if (!sel) return;
          var card = sel.closest('.cart-upsell__card');
          var add = card ? card.querySelector('[data-upsell2-add]') : null;
          var price = card ? card.querySelector('[data-upsell-price]') : null;
          if (add) add.setAttribute('data-variant-id', sel.value);
          var v = extraProduct ? extraProduct.variants.filter(function(x){ return String(x.id) === String(sel.value); })[0] : null;
          if (price && v) price.innerHTML = upsellPriceHtml(v.price, v.compare);
        });
        upsell2El.addEventListener('click', function(e){
          var add = e.target.closest('[data-upsell2-add]');
          if (!add) return;
          var id = add.getAttribute('data-variant-id');
          if (!id) return;
          add.disabled = true; var orig = add.textContent; add.textContent = T('Adding…');
          fetch(FX_ROOT + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({ id:id, quantity:1 }) })
            .then(function(r){ return r.json(); })
            .then(function(){
              var code = upsell2El.getAttribute('data-upsell-code');
              if(code){ return fetch(FX_ROOT + 'discount/' + encodeURIComponent(code), {headers:{'Accept':'text/html'}}).catch(function(){}); }
            })
            .then(function(){ fetchCart(false); })
            .catch(function(){})
            .then(function(){ add.disabled = false; add.textContent = orig; });
        });
      }

      /* ================= Pre-purchase upsell flow ================= */
      /* Shared: add a list of {id, quantity} line items, optionally apply the
         discount, then open the cart drawer. */
      function addItemsAndOpen(items, applyDiscount, spinnerBtn, spinnerOrig, onDone){
        fetch(FX_ROOT + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({ items: items }) })
          .then(function(r){ return r.json(); })
          .then(function(){
            var code = upsellEl ? upsellEl.getAttribute('data-upsell-code') : (upsell2El ? upsell2El.getAttribute('data-upsell-code') : '');
            if (applyDiscount && code){ return fetch(FX_ROOT + 'discount/' + encodeURIComponent(code), {headers:{'Accept':'text/html'}}).catch(function(){}); }
          })
          .then(function(){ return fetchCart(true); })   /* wait until the drawer is rendered + opened */
          .then(function(){ if(onDone) onDone(); })       /* only now dismiss the popup — no blank gap */
          .catch(function(){ window.location.href = FX_ROOT + 'cart'; })
          .then(function(){ if(spinnerBtn){ spinnerBtn.disabled=false; spinnerBtn.textContent=spinnerOrig; } });
      }

      var ppOverlay = null;
      function ppClose(){ if(ppOverlay){ ppOverlay.classList.remove('is-open'); } }
      function ppEnsureShell(){
        if (ppOverlay) return ppOverlay;
        ppOverlay = document.createElement('div');
        ppOverlay.className = 'pp-modal';
        ppOverlay.setAttribute('aria-hidden','true');
        ppOverlay.innerHTML = '<div class="pp-modal__overlay" data-pp-cancel></div><div class="pp-modal__box" role="dialog" aria-label="'+T('Special offer')+'"><button class="pp-modal__close" type="button" data-pp-cancel aria-label="'+T('Close')+'">&times;</button><div class="pp-modal__stage" data-pp-stage></div></div>';
        document.body.appendChild(ppOverlay);
        return ppOverlay;
      }
      /* Show the modal instantly with a spinner while the cart loads, so the
         customer gets immediate feedback after tapping Add to cart. */
      function ppShowLoading(){
        ppEnsureShell();
        var stage = ppOverlay.querySelector('[data-pp-stage]');
        if (stage) stage.innerHTML = '<div class="pp-modal__loading"><span class="pp-modal__spinner"></span></div>';
        ppOverlay.onchange = null;
        ppOverlay.onclick = function(e){ if (e.target.closest('[data-pp-cancel]')){ ppClose(); document.body.classList.remove('cart-open'); } };
        ppOverlay.classList.add('is-open');
        ppOverlay.setAttribute('aria-hidden','false');
      }
      /* Confirm the click INSIDE the popup and keep it open until the cart is truly
         ready — avoids the blank gap between the popup and the cart drawer. */
      function ppShowAdding(msg){
        ppEnsureShell();
        var stage = ppOverlay.querySelector('[data-pp-stage]');
        if (stage) stage.innerHTML = '<div class="pp-modal__loading"><span class="pp-modal__spinner"></span><div class="pp-modal__loading-txt">'+ (msg || T('One moment…')) +'</div></div>';
        ppOverlay.onchange = null;
        ppOverlay.onclick = null; /* block further clicks while adding */
        ppOverlay.classList.add('is-open');
        ppOverlay.setAttribute('aria-hidden','false');
      }

      /* Build the ordered list of offers to present before adding the main item. */
      function ppBuildOffers(cart, currentProductId, wantSize, wantBundle){
        var offers = [];
        var inCart = {};
        (cart.items || []).forEach(function(it){ inCart[it.product_id] = true; });
        /* Offer 1 — another colour of the panty (same idea as the in-cart upsell) */
        if (upsellProducts && upsellProducts.length){
          var cand = upsellProducts.filter(function(p){
            return p.id != currentProductId && !inCart[p.id] && p.variants.some(function(v){ return v.available; });
          });
          if (cand.length){ offers.push({ kind:'colour', product: cand[0] }); }
        }
        /* Offer 2 (extra-layer / liner popup) removed by request — only the
           "another pack" colour offer is shown after Add to cart. */
        return offers;
      }

      function ppPriceHtml(priceCents, compareCents){
        return (compareCents && compareCents > priceCents ? '<s class="pp-modal__compare">'+money(compareCents)+'</s> ' : '')+
               '<span class="pp-modal__now">'+ money(priceCents) +'</span>';
      }
      function ppGalleryHtml(images){
        if (!images || !images.length) return '<div class="pp-modal__main"><div class="pp-modal__img pp-modal__img--ph"></div></div>';
        var imgs = images.slice(0, 5); /* show at most 5 thumbnails */
        return '<div class="pp-modal__main"><img class="pp-modal__img" data-pp-mainimg src="'+imgs[0]+'" alt=""></div>'+
          (imgs.length > 1 ? '<div class="pp-modal__thumbs">'+
            imgs.map(function(src,i){ return '<button type="button" class="pp-modal__thumb'+(i===0?' is-active':'')+'" data-pp-thumb="'+i+'"><img src="'+src+'" alt=""></button>'; }).join('')+
          '</div>' : '');
      }
      function ppRenderOffer(offer, wantSize, wantBundle){
        var p = offer.product;
        var stage = ppOverlay.querySelector('[data-pp-stage]');
        var titleText, subText, optionsHtml, variantId, priceCents, compareCents;
        var images = (p.images && p.images.length) ? p.images : (p.image ? [p.image] : []);
        if (offer.kind === 'colour'){
          titleText = T('Add another color — <span class="pp-modal__getoff">get <span class="pp-modal__save">$10&nbsp;Off</span></span>');
          subText = '';
          var bundles = bundlesOf(p), sizes = allSizesOf(p);
          /* Preselect the "3 + 1" (bigger) pack. */
          var curBundle = preferBigBundle(bundles);
          /* Keep the exact size the customer already selected. */
          var curSize   = matchSize(sizes, wantSize) || (sizesOf(p)[0]) || sizes[0];
          var v = variantOf(p, curBundle, curSize);
          variantId = v ? v.id : ''; priceCents = v ? v.price : p.price; compareCents = v ? v.compare : 0;
          /* Show the selected variant's own image first (so the 3+1 pack shows the
             3+1 visual when that variant has a dedicated image). */
          if (v && v.image){ images = [v.image].concat(images.filter(function(s){ return s !== v.image; })); }
          optionsHtml =
            (bundles.length ? '<select class="pp-modal__select" data-pp-pack aria-label="'+T('Pack')+'">'+
              bundles.map(function(b){ return '<option value="'+b+'"'+(b===curBundle?' selected':'')+'>'+b+'</option>'; }).join('')+'</select>' : '')+
            (sizes.length ? '<select class="pp-modal__select" data-pp-size aria-label="'+T('Size')+'">'+
              sizes.map(function(s){ return '<option value="'+s+'"'+(s===curSize?' selected':'')+'>'+s+'</option>'; }).join('')+'</select>' : '');
        } else {
          titleText = T('Add an extra layer of security & get $10 off');
          subText = T('Add an extra layer of bladder leak protection inside your FLUXE underwear: perfect for heavier leaks, day & night.');
          var av = p.variants.filter(function(x){ return x.available; });
          var v2 = av[0];
          variantId = v2 ? v2.id : ''; priceCents = v2 ? v2.price : p.price; compareCents = v2 ? v2.compare : 0;
          optionsHtml = (av.length > 1 ? '<select class="pp-modal__select" data-pp-variant aria-label="'+T('Option')+'">'+
            av.map(function(x){ return '<option value="'+x.id+'">'+ (x.title && x.title !== 'Default Title' ? x.title : p.title) +'</option>'; }).join('')+'</select>' : '');
        }
        stage.innerHTML =
          '<div class="pp-modal__title">'+ titleText +'</div>'+
          (subText ? '<div class="pp-modal__sub">'+ subText +'</div>' : '')+
          '<div class="pp-modal__gallery">'+ ppGalleryHtml(images) +'</div>'+
          '<div class="pp-modal__ttl">'+ p.title +'</div>'+
          '<div class="pp-modal__price" data-pp-price>'+ ppPriceHtml(priceCents, compareCents) +'</div>'+
          (offer.kind === 'colour' ? '<div class="pp-modal__save-note">'+T('+ $10 off applied at checkout')+'</div>' : '')+
          (optionsHtml ? '<div class="pp-modal__row">'+ optionsHtml +'</div>' : '')+
          '<div class="pp-modal__actions">'+
            '<button type="button" class="pp-modal__decline" data-pp-decline>'+T('No, thanks')+'</button>'+
            '<button type="button" class="pp-modal__add" data-pp-add data-variant-id="'+variantId+'">'+T('Add to order')+'</button>'+
          '</div>';
      }

      /* Run the sequence: show each offer, collect accepted variant ids, then add
         the main item plus everything accepted. */
      function ppRun(mainItems, offers, wantSize, wantBundle, spinnerBtn, spinnerOrig){
        ppEnsureShell();
        /* the modal takes over now — release the Add-to-cart button */
        if (spinnerBtn){ spinnerBtn.disabled = false; spinnerBtn.textContent = spinnerOrig; }
        var accepted = [];
        var idx = 0;
        function finalize(){
          /* Keep the popup open with a loading state, then close it only once the
             cart drawer is actually rendered and open. The message reflects whether
             the customer accepted the upsell or declined it. */
          ppShowAdding(accepted.length > 0 ? T('Adding to your cart…') : T('Opening your cart…'));
          var items = mainItems.concat(accepted);
          addItemsAndOpen(items, accepted.length > 0, spinnerBtn, spinnerOrig, ppClose);
        }
        function next(){
          if (idx >= offers.length){ finalize(); return; }
          var offer = offers[idx];
          ppRenderOffer(offer, wantSize, wantBundle);
          ppOverlay.classList.add('is-open');
          ppOverlay.setAttribute('aria-hidden','false');
        }
        function recalcColour(){
          var offer = offers[idx];
          if (!offer || offer.kind !== 'colour') return;
          var p = offer.product;
          var packSel = ppOverlay.querySelector('[data-pp-pack]');
          var sizeSel = ppOverlay.querySelector('[data-pp-size]');
          var bundle = packSel ? packSel.value : bundlesOf(p)[0];
          var size   = sizeSel ? sizeSel.value : sizesOf(p)[0];
          var v = variantOf(p, bundle, size);
          var add = ppOverlay.querySelector('[data-pp-add]');
          var price = ppOverlay.querySelector('[data-pp-price]');
          if (add) add.setAttribute('data-variant-id', v ? v.id : '');
          if (price && v) price.innerHTML = ppPriceHtml(v.price, v.compare);
          /* keep the main image in sync with the chosen variant */
          if (v && v.image){
            var mainImg = ppOverlay.querySelector('[data-pp-mainimg]');
            if (mainImg) mainImg.src = v.image;
          }
        }
        ppOverlay.onchange = function(e){
          if (e.target.closest('[data-pp-pack],[data-pp-size]')){ recalcColour(); return; }
          if (e.target.closest('[data-pp-variant]')){
            var sel = e.target.closest('[data-pp-variant]');
            var add = ppOverlay.querySelector('[data-pp-add]');
            if (add) add.setAttribute('data-variant-id', sel.value);
            var offer = offers[idx];
            var v = offer && offer.product.variants.filter(function(x){ return String(x.id) === String(sel.value); })[0];
            var price = ppOverlay.querySelector('[data-pp-price]');
            if (price && v) price.innerHTML = ppPriceHtml(v.price, v.compare);
          }
        };
        ppOverlay.onclick = function(e){
          /* image gallery: thumbnail -> swap the main image */
          var thumb = e.target.closest('[data-pp-thumb]');
          if (thumb){
            var main = ppOverlay.querySelector('[data-pp-mainimg]');
            var timg = thumb.querySelector('img');
            if (main && timg){ main.src = timg.src; }
            ppOverlay.querySelectorAll('[data-pp-thumb]').forEach(function(t){ t.classList.remove('is-active'); });
            thumb.classList.add('is-active');
            return;
          }
          if (e.target.closest('[data-pp-cancel]')){ /* × / overlay = decline current + continue */
            idx++; next(); return;
          }
          if (e.target.closest('[data-pp-decline]')){ idx++; next(); return; }
          var add = e.target.closest('[data-pp-add]');
          if (add){
            var id = add.getAttribute('data-variant-id');
            if (id){ accepted.push({ id: id, quantity: 1 }); }
            idx++; next(); return;
          }
        };
        next();
      }

      /* promo code */
      var promoBtn = drawer.querySelector('[data-promo-apply]');
      if(promoBtn){
        promoBtn.addEventListener('click', function(){
          var code = (drawer.querySelector('[data-promo-input]').value || '').trim();
          if(code) window.location.href = FX_ROOT + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
        });
      }
      fetchCart(false);
    })();

  });
})();
